export default {
  title: 'مدیریت روش پرداخت ها',
  search:'جستجو ...',
  id: 'شناسه',
  nameFa : 'عنوان فارسی',
  nameEn : 'عنوان لاتین',
  status: 'وضعیت',
  statusActive: 'فعال',
  statusInActive: 'غیرفعال',
  loading:'در حال دریافت اطلاعات ...',
  operating:'عملیات',
  empty:'داده ای یافت نشد',
  success:'موفق',
  btnCreate:'اضافه کردن',
  next: 'بعدی',
  previous: 'قبلی',
  discountPercent:'درصد تخفیف',
  ErrorRetrievingInformation:'خطا در دریافت اطلاعات',
  deleteConfirm:'آیا از حذف این روش پرداخت مطمئن هستید؟'




}
